import React from "react";
import { DesktopMenu } from "./HeaderMenu.styled";
import {
  headerNavigationConstants,
  type NavigationItem,
} from "../../../constants/navigationConstants";
import { useLocation } from "react-router-dom";
import { ListItem } from "@mui/material";
import HeaderMenuDropdown from "./HeaderMenuDropdown";
import HeaderMenuItem from "./HeaderMenuItem";

interface HeaderMenuProps {
  title?: string;
}

const HeaderMenu: React.FC<HeaderMenuProps> = () => {
  const { pathname } = useLocation();
  return (
    <DesktopMenu>
      {headerNavigationConstants.map((page: NavigationItem, index) => (
        <ListItem key={index}>
          {page.route && (
            <HeaderMenuItem key={index} {...page} pathname={pathname} />
          )}
          {page.dropdown && (
            <HeaderMenuDropdown
              title={page.title}
              items={page.dropdown}
              pathname={pathname}
            />
          )}
        </ListItem>
      ))}
    </DesktopMenu>
  );
};

export default HeaderMenu;
